import {useAppSelector} from "../redux/hooks";
import {useEffect} from "react";
import {lessonPlayerStore} from "../redux/lesson/LessonPlayerStore";
import lessonService from "../services/lesson/lessonService";
import noteScorer from "../services/scorer/noteScorer";

interface IPitchDetectionStatusHook {
  isPitchDetectionEnabled: boolean;
}

/**
 * Responsibility: Notify components and non-components when pitch detection transitions from or to being enabled.
 *
 * Downside: This hook has dependencies which point in incorrect directions.
 * These would ideally not be dependencies of this hook.
 * - lessonService
 * - noteScorer
 * In the long run, there would be components for each of those, which subscribe to Redux changes themselves.
 * As a result, in the long run, this hook won't exist.
 * However, for now, it's a simple way to subscribe to Redux changes in non-component, non-hook based code.
 */
export const usePitchDetectionStatus = (): IPitchDetectionStatusHook => {
  const isEnabled = useAppSelector(lessonPlayerStore.getIsPitchDetectionEnabled);

  useEffect(() => {
    lessonService.pitchDetector?.onPitchDetectionEnabledChanged();
    noteScorer.onIsPitchDetectionEnabled_changed(isEnabled);
  }, [isEnabled]);

  return {
    isPitchDetectionEnabled: isEnabled,
  };
}
